import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ContentStatusQuery } from "../graphql/queries";
import type {
  ContentStatusQueryType,
  ContentStatusQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useContentStatusQuery = (
  options?: QueryHookOptions<
    ContentStatusQueryType,
    ContentStatusQueryVariablesType
  >
) => {
  return useQuery<ContentStatusQueryType, ContentStatusQueryVariablesType>(
    ContentStatusQuery,
    options
  );
};
